import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import 'react-phone-number-input/style.css';
import { findPhoneNumbersInText } from 'libphonenumber-js';
import PhoneInput from 'react-phone-number-input';
import {
  formatPhoneNumberIntl,
  isValidPhoneNumber
} from 'react-phone-number-input';

import classes from './PhoneInputForm.module.css';

const PhoneInputForm = props => {
  const [phone, setPhone] = useState();

  useEffect(() => {
    let validNumber = false;
    if (phone) {
      const phoneFormat = findPhoneNumbersInText(phone);
      if (phoneFormat.length > 0) {
        props.phoneHandler(
          phoneFormat[0].number.countryCallingCode,
          phoneFormat[0].number.nationalNumber
        );
      }
      validNumber = isValidPhoneNumber(phone);
    }
    // eslint-disable-next-line no-console
    console.log('validNumber', validNumber);
  }, [phone]);

  return (
    <div className={classes.textFieldPhone}>
      <PhoneInput
        className={classes.textField}
        international
        defaultCountry="MX"
        placeholder="Enter phone number"
        value={formatPhoneNumberIntl(phone)}
        onChange={setPhone}
      />
    </div>
  );
};

PhoneInputForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  phoneHandler: PropTypes.function
};

export default PhoneInputForm;
